<template>
    <div class="d-flex border-tp-lr" style="background-color: #272727">
        <v-fade-transition v-if="!hideControls">
            <v-icon v-if="open" class="flex-0" size="14">mdi-minus</v-icon>
            <v-icon v-else class="flex-0" size="14">mdi-plus</v-icon>
        </v-fade-transition>
        <!-- <v-divider vertical class="mx-2 primary" /> -->
        <v-sheet
            tile
            class="primary sub-title px-2 mr-2 padding-fix word-break half-title"
            :class="{
                'premium-title-100': premium && $breakpoint.xsOnly,
                // Inverted condition for displaying 'cashout' (so that when cashout is hidden, this class is applied)
                'half-title-no-cashout':
                    nonBetFairMarket ||
                    !market?.runners?.length ||
                    market.runners.length > 2
            }"
        >
            <div class="d-flex" style="height: 100%">
                <span
                    class="align-self-center white--text font-weight-bold text-uppercase premium-title mr-2"
                >
                    <small v-if="premium && $breakpoint.xsOnly">
                        {{ title }}
                    </small>
                    <span v-else>
                        {{ title }}
                    </span>
                </span>
            </div>
        </v-sheet>
        <v-card-actions class="px-0">
            <v-btn
                v-if="
                    !nonBetFairMarket &&
                    market &&
                    market.runners &&
                    market.runners.length > 0 &&
                    market.runners.length <= 2
                "
                v-bind="props"
                class="custom-button-icon"
                small
                @click="cashOutClicked()"
            >
                <div class="custom-button-font font-weight-bold">
                    <span v-if="setUp && setUp === 'bd-new'" class="f18 mx-1">
                        &#2547;
                    </span>
                    <v-icon v-else>mdi-currency-rupee</v-icon>
                    CashOut
                </div>
                <v-tooltip activator="parent" location="top">CashOut</v-tooltip>
            </v-btn>
        </v-card-actions>
        <div
            v-if="
                delayTime && !premium && $route.params.subCategory !== 'UOFGame'
            "
            class="d-flex align-center"
        >
            <play-icon
                name="timer"
                text="Timer"
                class="px-2"
                :size="10"
                :delay-time="delayTime"
            ></play-icon>
        </div>
        <span v-if="bookmaker && !premium" class="mr-1"></span>
        <div v-if="bookmaker" class="d-flex align-center">
            <play-icon name="fast" text="Instant Betting"></play-icon>
        </div>
        <span v-if="bookmakerCommmission && !premium" class="mr-1"></span>
        <div v-if="bookmakerCommmission && !premium" class="commission-sec">
            <play-icon
                v-if="bookmakerCommmission && !premium"
                name="commission"
                text="Commission"
                :max-commission="maxCommission"
                :text-commission="textCommission"
            ></play-icon>
        </div>
        <v-spacer
            v-if="(!premium && $breakpoint.xsOnly) || !$breakpoint.xsOnly"
        />
        <v-fade-transition>
            <v-sheet
                v-if="hideControls || open"
                :class="{
                    'odds-title-width-xs-2':
                        ($breakpoint.xsOnly || rightSide) && !oneTitle,
                    'odds-title-width-xs-1': $breakpoint.xsOnly && oneTitle,
                    'odds-title-width-smAndUp':
                        $breakpoint.smAndUp &&
                        !rightSide &&
                        !isBothFancyVisibleOnDesktop,
                    'odds-title-width-smAndUp-2':
                        $breakpoint.smAndUp &&
                        !rightSide &&
                        isBothFancyVisibleOnDesktop
                }"
                class="d-flex align-items-center"
                style="
                    background-color: #272727;
                    color: white;
                    border-top-right-radius: 1rem;
                "
            >
                <div
                    no-gutters
                    class="d-flex px-0 w-100"
                    :class="{
                        'justify-end':
                            isWidth1024pxAndBelow() && !isWidthBelow913px(),
                        'justify-center': isWidthBelow913px(),
                        'py-3': isWidth600pxAndAbove()
                    }"
                >
                    <v-col
                        v-for="(text, i) in sideText"
                        :key="i"
                        class="caption"
                        :class="{
                            'text-center px-0': $breakpoint.xsOnly,
                            'text-right col-6 px-0 py-0 px-2':
                                $breakpoint.smAndUp && i === 0,
                            'text-right':
                                text && (text === 'Back' || text === 'No'),
                            'text-left col-6 px-0 py-0 px-2':
                                $breakpoint.smAndUp && i === 1
                        }"
                    >
                        <strong v-if="market?.name !== 'Multi Bet'">
                            {{ text }}</strong
                        >
                        <strong v-else>&nbsp;</strong>
                    </v-col>
                </div>
            </v-sheet>
        </v-fade-transition>
    </div>
</template>
<script>
import { mapState } from "vuex"
import PlayIcon from "@/components/icons/PlayIcon"
export default {
    name: "SimpleBar",
    components: { PlayIcon },
    props: {
        market: { type: Object, default: () => {} },
        title: { type: String, default: "", required: true },
        hideControls: { type: Boolean, default: false, required: false },
        nonBetFairMarket: { type: Boolean, default: false, required: false },
        open: { type: Boolean, default: false, required: false },
        bookmaker: { type: Boolean, default: false, required: false },
        rightSide: { type: Boolean, default: false, required: false },
        premium: { type: Boolean, default: false, required: false },
        bookmakerCommmission: {
            type: Boolean,
            default: false,
            required: false
        },
        oneTitle: { type: Boolean, default: false, required: false },
        maxCommission: { type: Number, required: false, default: undefined },
        delayTime: { type: Number, required: false, default: undefined },
        sideText: { type: Array, default: () => ["Back", "Lay"] },
        isBothFancyVisibleOnDesktop: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    data() {
        return {
            textCommission: true,
            setUp: process.env.setUp,
            props: {}
        }
    },
    computed: {
        ...mapState({
            books: (state) => state.betBooks.data
        })
    },
    methods: {
        cashOutClicked() {
            this.$emit("cash-out-clicked")
        },
        isWidth1024pxAndBelow() {
            return window.innerWidth <= 1024
        },
        isWidthBelow913px() {
            // Because below 913px, the box's width changes.
            return window.innerWidth < 913
        },
        isWidth600pxAndAbove() {
            // Because below 600, the UI sizing changes.
            return window.innerWidth >= 600
        }
    }
}
</script>
<style lang="scss" scoped>
.word-break {
    word-break: break-all;
}

.half-title {
    width: 38%;

    @media only screen and (max-width: 600px) {
        line-height: 150%;
    }

    @media only screen and (max-width: 320px) {
        font-size: 0.6rem;
    }
}
.half-title-no-cashout {
    width: 50%;
    @media only screen and (max-width: 600px) {
        line-height: 150%;
    }
    @media only screen and (max-width: 320px) {
        font-size: 0.6rem;
    }
}
.premium-title-100 {
    width: calc(100% - 125px);
}

.custom-button-icon {
    padding: 0 !important;
    font-size: 0.6rem !important;
    height: 24px !important;

    .v-icon.notranslate.mdi.mdi-currency-rupee.theme--light {
        font-size: 0.8rem !important;
        // padding: 0 3px;
        height: 24px !important;
        // background: #ffffff;
        border-radius: 4px 0px 0px 4px;
    }

    .custom-button-font {
        padding: 0 5px;
        height: 24px !important;
        display: inline-flex !important;
        align-items: center;
        border-radius: 4px;
        background: rgb(243, 232, 138);
        // background: linear-gradient(0deg, #c6a352 0%, #f3e88a 50%, #c6a352 85%);
        background: linear-gradient(0deg, #e3cf76 50%, #c6a352 100%);
    }

    @media only screen and (max-width: 767px) {
        font-size: 0.6rem !important;
        margin-right: 4px;

        // .custom-button-font {
        //     padding: 0 1px;
        // }

        .v-icon.notranslate.mdi.mdi-currency-rupee.theme--light {
            font-size: 0.8rem !important;
            padding: 0 0px;
        }
    }

    @media only screen and (max-width: 390px) {
        margin-right: 5px !important;
        font-size: 0.5rem !important;
        letter-spacing: 0.5px !important;

        .v-icon.notranslate.mdi.mdi-currency-rupee.theme--light {
            font-size: 0.6rem !important;
        }
    }

    @media only screen and (max-width: 365px) {
        min-width: max-content !important;
        // padding: 5px !important;

        // .custom-button-font {
        //     display: none !important;
        // }

        .v-icon.notranslate.mdi.mdi-currency-rupee.theme--light {
            background: transparent;
        }
    }
    @media only screen and (max-width: 290px) {
        font-size: 0.3rem !important;
    }
}

.timer-sec,
.instant-bet,
.commission-sec {
    min-width: 25px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    @media only screen and (max-width: 320px) {
        font-size: 0.7rem;
        position: absolute;
        right: 0;
        top: 0.2rem;
    }
}

.timer-sec {
    right: 0px;
}

.instant-bet {
    right: 22px;
}

.commission-sec {
    right: 42px;
}
</style>
